export default __webpack_public_path__ + "static/media/icon_LAMOSS.bd0f0074.svg";